var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _defs2, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var Svg4 = function Svg4(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 870.5 254",
    style: {
      enableBackground: "new 0 0 870.5 254"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000135663269439882508960000004959369474934865324_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000085957303432313196200000011083349906639268256_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 831.8,
    height: 195.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165209653565183395250000000526340341035674501_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165209653565183395250000000526340341035674501_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M707,194.7H47c-25.9,0-47-20.4-47-45.5V46C0,21,21.1,0.6,47,0.6h737.2c25.9,0,47,20.4,47,45.5v56 c0,2.8-2.3,5.1-5.1,5.1c-2.8,0-5.1-2.3-5.1-5.1V46c0-19.5-16.5-35.3-36.8-35.3H47c-20.3,0-36.8,15.8-36.8,35.3v103.2 c0,19.5,16.5,35.3,36.8,35.3h660c2.8,0,5.1,2.3,5.1,5.1C712,192.4,709.8,194.7,707,194.7"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.9,87.2c0.9-0.8,1.5-1.9,1.5-3.2l1-17.3c0.2-3-2.5-5.5-5.7-4.7c-0.7,0.2-1.4,0.5-1.9,1 c-0.9,0.8-1.5,1.9-1.5,3.2l-1,17.2c-0.1,2.3,1.4,4.4,3.7,4.9C754.4,88.5,755.8,88.1,756.9,87.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.9,127.4c1.3,0.1,2.4-0.4,3.3-1.2c0.9-0.8,1.5-1.9,1.5-3.2c0.1-1.2-0.4-2.4-1.2-3.3c-0.8-0.9-2-1.5-3.2-1.5 l-17.3-0.9c-2.8-0.2-5.1,2.2-4.8,5.1c0.2,2.2,2.2,3.9,4.4,4.1L709.9,127.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M779.5,101.2c1.8,1.4,4.3,1.3,6-0.3l12.8-11.4c1.7-1.5,2.1-4,0.9-5.9c-1.6-2.5-4.9-2.8-7-1l-12.9,11.6 C777.2,96,777.2,99.3,779.5,101.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M710.8,167.7l12.9-11.6c2.1-1.9,2.1-5.2-0.2-7c-1.8-1.4-4.3-1.3-6,0.3l-12.8,11.4c-1.7,1.5-2.1,4-0.9,6 C705.4,169.2,708.7,169.6,710.8,167.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M727.4,97c1.4-1.8,1.3-4.3-0.2-6l-11.4-12.8c-1.5-1.7-4-2.1-6-0.9c-2.5,1.6-2.8,4.9-1,7l11.6,12.9 C722.3,99.3,725.6,99.3,727.4,97"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155856370031073345090000007525185529019571375_",
    x: 734.7,
    y: 108.6,
    width: 135.5,
    height: 145.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087381181425819616800000009173010416945607579_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155856370031073345090000007525185529019571375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000087381181425819616800000009173010416945607579_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M854.1,157.4c0,0.4,0,1.5-1.1,2.1L827.3,174c-0.1,0.1-0.3,0.2-0.4,0.3c-1.1,0.8-1.8,2-1.9,3.3 c-0.1,1.1,0.3,2.2,0.9,3c0.1,0.2,35.2,39.3,35.3,39.6l-27.7,24.7l-35.2-39.3c-0.2-0.3-0.5-0.5-0.8-0.7c-1.9-1.4-4.8-0.9-6.1,1.1 l-17.2,23.9c-0.7,1-1.8,1-2.2,0.9c-0.4-0.1-1.4-0.4-1.7-1.6l-26.1-104.6c-1.1-4.3,3.2-8.2,7.3-6.6l101,37.6 C853.9,156,854.1,157,854.1,157.4z M855.8,147.2l-101-37.6c-5.1-1.9-10.7-0.8-14.7,2.8c-4,3.6-5.7,9.1-4.4,14.3l26.1,104.6 c1.9,8,12.1,11.2,18.2,5.6c0.6,0,14.9-20.4,15.6-21.2l31.8,35.6c3.1,3.4,8.4,3.7,11.8,0.7l28.5-25.5c3.4-3.1,3.7-8.4,0.7-11.8 L836.5,179l20.9-11.7c3.8-2.2,6-6.2,5.6-10.6C862.7,152.3,859.9,148.7,855.8,147.2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.930292, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-36.4-282.5c7.9,0,13.1-3.2,13.1-7.8c0-4-3.2-6.1-10.6-6.9l-4.9-0.6c-3.3-0.4-4.8-1.1-4.7-2.3 c0-1.7,2.6-2.8,6.3-2.8c3.8,0,7.6,1.3,9.7,3.3l2.2-3.7c-2.5-2.3-7-3.8-12-3.8c-7.5,0-12.7,2.8-12.7,7.5c0,3.8,2.9,5.8,9.6,6.6 l4.9,0.7c4,0.5,5.7,1.4,5.7,2.7c0,1.7-2.5,2.8-6.4,2.8c-4.9,0-9.9-1.9-12.2-4.6l-2.6,3.8C-48.2-284.7-42.4-282.5-36.4-282.5z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.578426, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-42.7-283.3h6.5v-23.2h-6.5V-283.3z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.908503, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-25.5-282.6c5.2,0,9.7-2,11.9-5h0l0.3,4.3H-8v-13.2h-20.9v3.6h14.6c-0.2,3.4-4.2,5.8-9.4,5.8 c-6.2,0-10.4-3.2-10.4-7.7c0-4.7,3.9-7.8,9.5-7.8c3.6,0,6.9,1.6,7.7,3.9l6.1-1.1c-1.1-4.4-6.8-7.3-13.8-7.3 c-9.5,0-16,5.1-16,12.6C-40.7-287.5-34.5-282.6-25.5-282.6z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.150123, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-31.5-283.3h6.2v-17h0l14.6,17h8v-23.2h-6.3v16.9h0l-14.5-16.9h-8V-283.3z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.192734, 388.231379)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.594335, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-7.5-282.6c8.8,0,14.2-4,14.2-11.2v-12.6H0.2v12.3c0,4.5-3,6.7-7.6,6.7c-4.7,0-7.6-2.2-7.6-6.7v-12.3h-6.6 v12.6C-21.7-286.6-16.3-282.6-7.5-282.6z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.830654, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-13.6-283.3H-7v-7.6H4.2c6.3,0,9.7-2.8,9.7-7.7c0-5-3.5-7.9-9.7-7.9h-17.9V-283.3z M-7-294.8v-7.7h9.3 c3.3,0,5.2,1.4,5.2,3.8c0,2.5-1.9,3.9-5.2,3.9H-7z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(281.162927, 388.231379)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.564499, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-4-283.3h6.6v-8.9h14.9v-4H2.5v-5.5h16.8v-4.8H-4V-283.3z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.744871, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5-282.5c9.9,0,16.6-5,16.6-12.4c0-7.4-6.7-12.4-16.6-12.4c-9.9,0-16.6,5-16.6,12.4 C1.9-287.5,8.6-282.5,18.5-282.5z M18.5-287.2c-6,0-10-3.1-10-7.7s4.1-7.7,10-7.7c6,0,10.1,3.1,10.1,7.7S24.5-287.2,18.5-287.2z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.352993, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1-282.6c2,0,4.1-0.8,5.2-2l-1.4-2.8c-0.5,0.6-1.2,1-1.8,1c-0.9,0-1.4-0.5-1.9-1.2l-1.6-2.8 c-0.6-1-1.3-1.9-2.2-2.3v0c4.2-0.7,6.8-3.1,6.8-6.6c0-4.5-3.5-7.1-9.3-7.1H11.3v23.2h6.6v-8.3h7.1c1.6,0,3,0.8,3.9,2.3l1.6,3 C31.5-284.4,33.1-282.6,36.1-282.6z M17.8-295.6v-6.8h10.3c2.8,0,4.5,1.3,4.5,3.4c0,2.1-1.7,3.4-4.5,3.4H17.8z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.102417, 388.231379)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.503987, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.3-283.3h6.2v-16.5h0.1l8.8,16.5h5.9l8.6-16.5H51v16.5h6.2v-23.2h-8.8l-9.2,17.4h-0.1L30-306.5h-8.7 V-283.3z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.873107, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9-283.3h6.6v-8.2l11.2-15h-7.1L44.2-296h0l-7.6-10.5h-7.1l11.4,15V-283.3z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(414.765618, 388.231379)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(421.167138, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.1-283.3h7.5l7.6-18h0l7.5,18h7.6l10.1-23.2h-6.7l-7.4,18h-0.1l-7.3-18h-7.6l-7.3,18h0l-7.5-18h-6.7 L49.1-283.3z"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(459.063616, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2-283.3h24.1v-4.3H59.5v-5.7h16.2v-3.8H59.5v-5.2H77v-4.3H53.2V-283.3z"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.879263, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8-283.3h19.1c5.4,0,8.7-2.5,8.7-6.4c0-2.6-1.7-4.7-4.4-5.4v-0.1c2.3-0.8,3.8-2.6,3.8-5 c0-3.9-3.2-6.3-8.4-6.3H59.8V-283.3z M66.3-296.9v-5.8h10.2c2.4,0,3.9,1.1,3.9,2.9c0,1.8-1.5,2.9-3.9,2.9H66.3z M66.3-287.1v-6.3 h10.4c2.6,0,4.3,1.2,4.3,3.1s-1.7,3.1-4.3,3.1H66.3z"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.504686, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3-283.3h6.5v-23.2h-6.5V-283.3z"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.834766, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.7-283.3H76v-17h0l14.6,17h8v-23.2h-6.3v16.9h0l-14.5-16.9h-8V-283.3z"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.877364, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.2-283.3H83l2.2-4.6h13l2.2,4.6h6.8l-11.6-23.2h-7.6L76.2-283.3z M86.7-291.8l5.1-10.5h0.1l5,10.5H86.7z"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.309163, 388.231379)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.4-282.6c2,0,4.1-0.8,5.2-2l-1.4-2.8c-0.5,0.6-1.2,1-1.8,1c-0.9,0-1.4-0.5-1.9-1.2l-1.6-2.8 c-0.6-1-1.3-1.9-2.2-2.3v0c4.2-0.7,6.8-3.1,6.8-6.6c0-4.5-3.5-7.1-9.3-7.1H85.6v23.2h6.6v-8.3h7.1c1.6,0,3,0.8,3.9,2.3l1.6,3 C105.8-284.4,107.4-282.6,110.4-282.6z M92.1-295.6v-6.8h10.3c2.8,0,4.5,1.3,4.5,3.4c0,2.1-1.7,3.4-4.5,3.4H92.1z"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(580.058578, 388.231379)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(586.46017, 388.231379)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/4.fbbcc54c61e7fadd0fb24192615b3fab.svg";